function DaySelector({ days, selectedDay, onSelect }) {
  return (
    <div className="day-selector" role="tablist" aria-label="Select LEAP day">
      {days.map((day) => (
        <button
          key={day.id}
          role="tab"
          aria-selected={selectedDay === day.id}
          className={`day-tab ${selectedDay === day.id ? 'active' : ''}`}
          onClick={() => onSelect(day.id)}
        >
          <span className="day-tab-label">{day.label}</span>
          <span className="day-tab-date">{day.displayDate}</span>
        </button>
      ))}
    </div>
  );
}

export default DaySelector;
